import { processesRepo } from '@/constants/providers';
import { useMutation } from '@tanstack/react-query';
import { AttachUserProcessModel } from '../types/attach-user-entity-model';

export const useAttachUserProcess = () =>
  useMutation<void, unknown, AttachUserProcessModel>((userProcess) =>
    processesRepo.attachUserProcess(userProcess),
  );
